/**
 * Created by tayloremolo on 11/4/17.
 */
import React, {Component} from 'react';
import ReactDOM from "react-dom";

class JoinusSection extends Component {
    // constructor() {
    //     super();
    //
    // }
    // componentDidMount(){
    //     });
    // }

    render() {

        return (
            <div>
                <div className="brand-blue-4 z-22">
                    <div className="container p-40 relative-text">
                        <div className="row mb0">
                            <div className="col s12 p0 center-align">
                                <h1 className="f-52 white-text bold-text text-uppercase mb0">Join Us At<br/><span className="f-84 ls-5 white-text">" Take <span className="brand-text">Own</span>ership "</span></h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section-18-et z- p-40">
                    <div className="container p-40 relative-text">
                        <div className="row mb0">
                            <div className="col s12 center-align">
                                <h1 className="f-84 ls-5 black-text-opacity bolder-text text-uppercase mb0">THE TIME IS NOW<br/></h1>
                            </div>
                        </div>
                        <br className="hide-on-small-only"/><br className="hide-on-small-only"/><br/>
                        <div className="row mb0 black-box p-40 white-border-all">
                            <div className="col s12 left-align mobile-center">
                                <h1 className="f-32 white-text bold-text text-uppercase mb0">THE OPPORTUNITY IS EXTREMELY LIMITED<br/></h1>
                                <p className="f-18 white-text">If you’re serious about taking your success to the next level, or maybe just getting started in business for yourself, you owe it to yourself to TAKE OWNERSHIP of your future by signing up for this 2-DAY ONLY mastermind experience! Dr. Thomas has taken his unique brand of success and shared it with millions all around the globe! In December, 2017, he’s touching down in Newark, Nj to give you the tools you’ll need to TAKE OWNERSHIP of your future! Space is limited and seats are going fast! Isn’t it time you took control of your success? You won’t want to miss this event powered by Fownders.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

}

export default JoinusSection;


// WEBPACK FOOTER //
// ./src/components/joinus-section.js